<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('animal.Pedigree') }}</h5>
    <p class="mb-0 text-sm">{{ $t('animal.Optional_information') }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <p class="fw-bold">{{ $t('animal.Father_details') }}</p>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Country') }}</label>  
            <select id="fatherCountryCodeId" v-model="localFormData.fatherCountryCodeId" class="form-control form-control-default">
                <option value="">{{ $t('animal.Select_country') }}</option>
                <option v-for="item in formData.countryCodes" :key="item.id" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('animal.Father_tagnumber') }}</label>
            <input v-model="localFormData.fatherTagNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Father_tagnumber')"> 
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('animal.Father_studbook_number') }}</label>
            <input v-model="localFormData.fatherStudbookNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Father_studbook_number')"> 
          </div>
        </div>
      </div>
      <div class="row mt-3">
          <p class="fw-bold">{{ $t('animal.Mother_details') }}</p>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Country') }}</label>  
              <select id="motherCountryCodeId" v-model="localFormData.motherCountryCodeId" class="form-control form-control-default">
                  <option value="">{{ $t('animal.Select_country') }}</option>
                  <option v-for="item in formData.countryCodes" :key="item.id" :value="item.id">
                      {{ item.name }}
                  </option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Mother_tagnumber') }}</label>
              <input v-model="localFormData.motherTagNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Mother_tagnumber')"> 
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.Mother_studbook_number') }}</label>
              <input v-model="localFormData.motherStudbookNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Mother_studbook_number')"> 
            </div>
          </div>
      </div>
      <div class="row mt-3">
          <p class="fw-bold">{{ $t('animal.Receipent_mother') }}</p>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label>{{ $t('animal.Country') }}</label>  
              <select id="receipientMotherCountryCodeId" v-model="localFormData.receipientMotherCountryCodeId" class="form-control form-control-default">
                  <option value="">{{ $t('animal.Select_country') }}</option>
                  <option v-for="item in formData.countryCodes" :key="item.id" :value="item.id">
                      {{ item.name }}
                  </option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.ReceipentMother_tagnumber') }}</label>
              <input v-model="localFormData.receipientMotherTagNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.ReceipentMother_tagnumber')"> 
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('animal.ReceipentMother_studbook_number') }}</label>
              <input v-model="localFormData.receipientMotherStudbookNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.ReceipentMother_studbook_number')"> 
            </div>
          </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">{{ $t('common.Prev') }}</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>                
      </div>
    </div>
  </div>
</template>

<script>
  import { reactive, watch } from 'vue'

  export default {
    name: "PedigreeSection",
    props: {
      countryCodes: Array,
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    setup(props, { emit }) {
      const localFormData = reactive({ ...props.formData })
      
      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndNextStep = async () => {
          props.nextStep()
      }

      return {
        localFormData,
        validateAndNextStep
      }
    }    
};
</script>